(function($, _) {
  var ns = window.nspace("ccc.viz.table.views");

  // Clever way to tell if we are sorting by a number.
  // From here: http://stackoverflow.com/questions/18082/validate-numbers-in-javascript-isnumeric/1830844#1830844
  function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  /**
   * The main data table
   */
  ns.DataTableView = Backbone.View.extend({
    el: "#data-table-container",
    templateSelector: "#data-table-template",
    name: "DataTableView",

    initialize: function(options) {
      var self = this;
      this.initialRenderPromise = $.Deferred();

      _.bindAll(
        this,
        "render",
        "loadTemplate",
        "sortData",
        "onBeforeChange",
        "getInitialRenderPromise"
      );

      this.dataResponseModel = options.dataResponseModel;

      this.model.on("change", this.render);

      // Handle the before change event so that we have an opportunity to update the
      // Sort Column when the indicator ID changes. This will prevent multiple "change"
      // events from being emitted in response to changing the indicator.
      this.model.on("before-change", this.onBeforeChange);

      // Listen for clicks on the sort buttons and update the selectors model
      this.$el.on(
        "click",
        "button[data-sort-up], button[data-sort-down]",
        function() {
          var props = {
            sortColumn: $(this).data("column")
          };

          if ($(this).is("[data-sort-up]")) {
            props.sortDirection = "u";
          }
          else {
            props.sortDirection = "d";
          }

          self.model.set(props);
        }
      );
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    onBeforeChange: function(newProps) {
      // If the indicator ID is changing, then remove the selected sort column
      if (this.model.get("indicatorId") !== newProps.indicatorId) {
        newProps["sortColumn"] = null;
        newProps["sortDirection"] = null;
      }
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    sortData: function(response) {
      var self = this;

      var sortColumn = this.model.get("sortColumn");
      if (sortColumn == null || sortColumn === "a") {
        return response;
      }

      // Iterate over rows in the table and gather the items to be sorted
      var outputRows = [];
      var locationTypeHeaders = [];
      var locationRowsByType = {};
      var nycRow;
      _.each(response.rows, function(row) {
        // If it's a header row, just copy it straight to the output
        if (row.rowType === "Header") {
          outputRows.push(row);
          return;
        }

        // NYC (location type ID 1) always stays alone at the top, so save it off separately
        if (row.locationTypeId === 1) {
          nycRow = row;
          return;
        }

        // Save off the location type rows
        if (row.rowType === "LocationType") {
          locationTypeHeaders.push(row);
          return;
        }

        // Any remaining rows must be a data row. Index them by location type
        if (!locationRowsByType.hasOwnProperty(row.locationTypeId)) {
          locationRowsByType[row.locationTypeId] = [];
        }
        locationRowsByType[row.locationTypeId].push(row);
      });

      // Sort each group of location rows by the specified column
      for (var locTypeId in locationRowsByType) {
        var rows = locationRowsByType[locTypeId];

        // Clone the rows so that we're not modifying to original instance
        var clone = [];
        _.each(rows, function(row) {
          clone.push(_.clone(row));
        });
        rows = clone;

        var numWithoutData = 0;
        var sorted = _.sortBy(rows, function(row) {
          // If we're sorting by the first column, it's location names, so sort by alpha
          if (sortColumn === 0) {
            return row.cells[0].displayValue;
          }

          // Are we sorting by abbreviation?
          if (sortColumn === "abbr") {
            var cell = row.cells[0];
            return _.str.isBlank(cell.abbreviation)
              ? cell.displayValue
              : // Sometimes the abbreviations are numbers that vary in # of decimal places.
              // Detect numbers and parse them out.
              isNumber(cell.abbreviation)
                ? parseFloat(cell.abbreviation)
                : cell.abbreviation;
          }

          // Otherwise, sort by the data value
          if (row.cells[sortColumn].hasOwnProperty("value")) {
            return row.cells[sortColumn].value;
          }

          // No value? Sort to bottom
          numWithoutData++;
          return self.model.get("sortDirection") === "d"
            ? Number.MIN_VALUE
            : Number.MAX_VALUE;
        });

        // Reverse the order if we're sorting highest first
        if (this.model.get("sortDirection") === "d") {
          sorted.reverse();
        }

        // Save the results
        locationRowsByType[locTypeId] = sorted;
      }

      // Reassemble the output
      outputRows.push(nycRow);
      _.each(locationTypeHeaders, function(locTypeHeader) {
        outputRows.push(locTypeHeader);

        var locationRowsForThisType = locationRowsByType[locTypeHeader.locationTypeId];
        if (locationRowsForThisType) {
          outputRows = outputRows.concat(locationRowsForThisType);
        }
      });

      var sortedResponse = _.extend({}, response);
      sortedResponse.rows = outputRows;

      return sortedResponse;
    },

    /**
     * Renders the data table
     */
    render: function() {
      var self = this;

      this.loadTemplate();

      // If the only thing that changed was sorting, we want to show the transition differently
      var sortChangedCount = _.filter(_.keys(self.model.changed), function(
        key
      ) {
        return key === "sortColumn" || key === "sortDirection";
      }).length;

      var onlySortChanged = _.size(self.model.changed) === sortChangedCount;

      if (!onlySortChanged) {
        this.$el.css("visibility", "hidden");
      }

      // Get the data to display
      $.when(this.dataResponseModel.getDataResponse()).done(function() {
        // Gather the properties necessary to render the template
        var response = self.dataResponseModel.get("response");

        // Apply sorting, if any
        response = self.sortData(response);

        // Data summary -- Pull it from the global selectors instance.
        var getSummaryFunc =
          ccc.viz.table.views.instances.SelectorsView
            .getDataSummaryByPropertyNames;
            
	var summary1 = response.indicatorGroupName;

        if (!_.str.isBlank(response.currentDistributionName)) {
          summary1 += ": " + response.currentDistributionName;
        }
        var summary2 = getSummaryFunc(["timeFrameId", "dataFormatId"]);

        // Update the data summary up in the selector area (Maybe this should be in a different view? Meh.)
        var distro = _.str.isBlank(response.currentDistributionName)
          ? ""
          : response.currentDistributionName + "; ";
        var dataSummary = distro + summary2;
        $("#data-summary").text(dataSummary);

        // Assemble the data necessary to render the template
        var templateData = _.extend(
          {
            sortColumn: self.model.get("sortColumn"),
            sortDirection: self.model.get("sortDirection"),
            summary1: summary1,
            summary2: summary2
          },
          response
        );

        // Render the contents
        self.$el.html(self.template(templateData));

        // Ensure we're visible / animate the transition
        self.$el.css("visibility", "visible");

        // If the only thing that changed was sorting, only animate the rows after the headers
        if (onlySortChanged) {
          $("tr:not(.table-sort-row):not(.column-title-row)", self.el)
            .hide()
            .fadeIn(function() {
              self.initialRenderPromise.resolve();
            });
        }
        // Otherwise, animate the whole thing
        else {
          self.$el.hide().fadeIn(function() {
            self.initialRenderPromise.resolve();
          });
        }
      });
    }
  });
})(jQuery, _);
